import * as React from 'react';
import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import FavoriteIcon from '@mui/icons-material/Favorite';
import AddIcon from '@mui/icons-material/Add';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import SearchIcon from '@mui/icons-material/Search';
import LogoutIcon from '@mui/icons-material/Logout';
import { useSignOut } from 'react-firebase-hooks/auth';
import { getAuth } from "firebase/auth"


export default function BottomMenu({ setOpenFilter, setFavorites, favoritesFilter, setPendingChange }) {
  const [value, setValue] = React.useState(0);
  const [signOut] = useSignOut(getAuth());
  const { t } = useTranslation();

  const handleDrawerOpen = () => {
    setOpenFilter(true);
  };

  const handleShowFavoritesChange = (event) => {
    setFavorites(!favoritesFilter)
    setPendingChange(true)
  };

  const handleLogout = () => {
    signOut();
  }


  return (
    <Box sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, background: 'white' }}>
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        sx={{ marginBottom: 3 }}
      >
        <BottomNavigationAction label={t('filter')} onClick={handleDrawerOpen} icon={<SearchIcon />} />
        <BottomNavigationAction label={t('filterBy.favorite')} onClick={handleShowFavoritesChange}  icon={favoritesFilter ? <FavoriteIcon /> : <FavoriteBorderIcon />} />
        <BottomNavigationAction label={t('newOutfit.title')} component={Link} to="/newOutfits" icon={<AddIcon />} />
        <BottomNavigationAction label={t('LogOut')} onClick={handleLogout} icon={<LogoutIcon />} />
      </BottomNavigation>
    </Box>
  );
}
